function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 6a4 4 0 104 4 4 4 0 00-4-4zm0 6a2 2 0 112-2 2 2 0 01-2 2z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.44.402C6.683.584 2.46 4.81 2.342 9.565c-.058 2.994 1.595 5.667 3.06 8.173 1 1.56 2.007 3.14 3.218 4.545 1.855 1.8 5.114 1.757 6.889-.14 1.231-1.341 2.08-2.976 3.116-4.463 1.457-2.388 2.91-4.938 3.027-7.8.013-4.454-3.492-8.6-7.913-9.331-.745-.136-1.531-.17-2.3-.147zM12 1.807c3.894-.024 7.568 3.034 8.13 6.91.347 2.01-.33 4.017-1.34 5.734-1.282 2.48-2.759 4.89-4.625 6.974-1.626 1.367-4.376.74-5.315-1.15-1.993-2.779-3.948-5.698-4.93-9.004-.872-4.241 2.427-8.705 6.676-9.315.462-.094.934-.124 1.404-.15z"
});

function SvgMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: "w-full h-full fill-current"
  }, props), _ref, _ref2);
}

export default SvgMarker;